import { Box, Typography } from "@mui/material";
import ThriveCaseSelection from "../common/ThriveCaseSelection";
import { useEffect } from "react";
import { axiosInstance } from "../../utils/networking";
import ThriveActivitySelection from "../common/ThriveActivitySelection";

interface EngagementsSearchResultProps {
  searchTerm: string;
  searchResults: {
    case_results: any[];
    activity_results: any[];
    referral_docs: any[];
  };
}

const EngagementsSearchResult: React.FC<EngagementsSearchResultProps> = ({
  searchTerm,
  searchResults,
}) => {
  // useEffect(() => {
  //   axiosInstance.post(`/search?query=${searchTerm}`).then((response) => {
  //     console.log("Search results:", response.data);
  //   });
  // }, [searchTerm, searchResults]);

  // console.log("Search Results in search Dashboard:", searchResults);
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
      <div className=" col-span-1">Coming Soon...</div>
      <div className=" col-span-1">
        <div className="rounded-lg shadow-md inset-0">
          <Box
            sx={{
              textAlign: "center",
              backgroundColor:
                process.env.REACT_APP_API_DOMAIN !=
                "https://www.thrive-drive.org:8443"
                  ? "rgb(63, 93, 125)"
                  : "rgb(158, 31, 99)",
              padding: "3px",
              margin: 0,
              color: "white",
              borderRadius: "15px 15px 0 0",
            }}
          >
            <Typography sx={{ display: "inline-block" }} variant="h6">
              Activities
            </Typography>
          </Box>

          <ThriveActivitySelection
            height={670}
            cases={searchResults["activity_results"]}
            searchTerm={searchTerm}
          ></ThriveActivitySelection>
        </div>
      </div>
      <div className=" col-span-1">
        <div className="rounded-lg shadow-md inset-0">
          <Box
            sx={{
              textAlign: "center",
              backgroundColor:
                process.env.REACT_APP_API_DOMAIN !=
                "https://www.thrive-drive.org:8443"
                  ? "rgb(63, 93, 125)"
                  : "rgb(158, 31, 99)",
              padding: "3px",
              margin: 0,
              color: "white",
              borderRadius: "15px 15px 0 0",
            }}
          >
            <Typography sx={{ display: "inline-block" }} variant="h6">
              Cases
            </Typography>
          </Box>

          <ThriveCaseSelection
            height={670}
            cases={searchResults["case_results"]}
            reloadCases={false}
            checkedCases={[]}
            setCheckedCases={() => {}}
            selectedCase={{}}
            setSelectedCase={() => {}}
            enableControl={false}
            enableSelection={false}
            enableMultiSelection={false}
            title=""
            status_default="either"
            sortby_default="recent"
            period_default="2w"
            setOpen={() => {}}
            handleNext={() => {}}
          ></ThriveCaseSelection>
        </div>
      </div>
    </div>
  );
};

export default EngagementsSearchResult;
